import { Injectable } from '@angular/core';
import { ExportContext, ExportFileFormat, ExportRange, ExportService } from 'app/layout/export-overlay';
import { buildQuery, page, seed } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { takeUntil } from 'rxjs';
import get from 'lodash-es/get';
import ceil from 'lodash-es/ceil';
import { format, parseISO } from 'date-fns';
import { LOCALIZED_PROPERTIES, PRICE_LIST_EXPORT_ID, PRICE_LIST_TITLE } from './price-list.constants';
import { PriceListService } from '../price-list.service';
import PriceListAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/price-list/price-list.entity';

const typeList : { valor: string; label: string }[] = [
  { valor: 'D', label: 'DESCUENTO' },
  { valor: 'P', label: 'PRECIO' },
  { valor: 'G', label: 'PROMOCIÓN'}
];

@Injectable()
export class PriceListExport {
  constructor(
    private exportService: ExportService,
    private priceListService: PriceListService,
  ) {}
//cambiar atributo
  private transformItem(item: PriceListAttributes) {
    return {
      code: get(item, 'code', '??'),
      name: get(item, 'name', '??'),
      type: this.getName(get(item, 'type', '')),
      statusId: this.getStatus(get(item, 'statusId', '')),
    };
  }

  private getStatus(value: string | number): string {
    if(!value && value !== 0) {
        return '';
    }
    return value === 1 ? 'Activo' : 'Inactivo';
  }

  private getName(value: string): string {
    const item = typeList.find(type => type.valor === value);
    return item ? item.label : value;
  } 

  export(format: ExportFileFormat, range: ExportRange, totalItems: number, pageSize: number, pageIndex: number) {
    const totalPages = ceil(totalItems / pageSize) + 1;
    this.exportService.task({
      id: PRICE_LIST_EXPORT_ID,
      title: PRICE_LIST_TITLE,
      format: format,
      iterations: range === ExportRange.AllPages ? totalPages : 1,
      start: (ctx: ExportContext) => {
        ctx.processor.localizeItemProperties(PRICE_LIST_TITLE, LOCALIZED_PROPERTIES);
      },
      next: (ctx: ExportContext) => {
        const currentPage = range === ExportRange.AllPages ? ctx.iteration : pageIndex;
        this.priceListService.findByFilter(buildQuery(
          seed(this.priceListService.currentFilter), page(currentPage, pageSize)
        ), { contextHeader: 'export' }).pipe(takeUntil(ctx.stopped)).subscribe((response) => {
          get(response, 'data.0.data', []).map((item) => {
            ctx.processor.addToSection(PRICE_LIST_TITLE, this.transformItem(item));
          });
          ctx.next();
        });
      },
    }).start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(PRICE_LIST_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}
